<template>
  <div ref="layout" class="l_bg">
    <canvas id="canvas"></canvas>
  </div>
</template>

<script>
export default {
  props: {
    canvasWidth: {
      default: 1920 * (1720/1920),
      type: Number
    },
    canvasHeight: {
      default: 1080 * (1720/1920),
      type: Number
    }
  },
  data() {
    let devicePixelRatio = window.devicePixelRatio || 1;

    return {
      realWidth: 1920,
      realHeigth: 1080,
      devicePixelRatio,
      interval: null,
      activeIdx: 0,
      direction: "",
      frameIndex:0
    };
  },
  computed: {
    imgWidth() {
      return this.canvasWidth;
    },
    imgHeight() {
      return this.canvasHeight;
    },
    fixCanvasWidth() {
      return this.canvasWidth * this.devicePixelRatio;
    },
    fixCanvasHeight() {
      return this.canvasHeight * this.devicePixelRatio;
    },
    ctx() {
      var mycanvas = document.getElementById("canvas");
      var ctx = mycanvas.getContext("2d");
      mycanvas.setAttribute("width", this.fixCanvasWidth);
      mycanvas.setAttribute("height", this.fixCanvasHeight);
      mycanvas.style.width = this.imgWidth + "px";
      mycanvas.style.height = this.imgHeight + "px";
      return ctx;
    },
    img() {
      let img = new Image();
      img.src = this.$cdn + `images/xuliezhen.jpg`;
      return img;
    }
  },
  watch: {
    height(){
      this.init();
    },
    direction(newVal) {
      if (newVal) {
        this.clsInterval();
        this.interval = setInterval(() => {
          this.ctx.clearRect(0, 0, this.fixCanvasWidth, this.fixCanvasHeight);
          this.ctx.drawImage(
            this.img,
            this.frameIndex * this.realWidth,
            0,
            this.realWidth,
            this.realHeigth,
            (this.fixCanvasWidth - this.imgWidth * this.devicePixelRatio) / 2,
            0,
            this.imgWidth * this.devicePixelRatio,
            this.imgHeight * this.devicePixelRatio
          );

          if (newVal === 'right') {
            if (this.frameIndex >= 29) {
              clearInterval(this.interval);
              return;
            }
            this.frameIndex++;
          }else{
            if (this.frameIndex === 0) {
              clearInterval(this.interval)
              return
            }
            this.frameIndex--
          }
        }, 20);
      }
    }
  },
  methods: {
    init() {
      this.$showLoading()
      this.img.onload = () => {
        this.ctx.clearRect(0, 0, this.fixCanvasWidth, this.fixCanvasHeight);
        this.ctx.drawImage(
          this.img,
          0,
          0,
          this.realWidth,
          this.realHeigth,
          (this.fixCanvasWidth - this.imgWidth * this.devicePixelRatio) / 2,
          0,
          this.imgWidth * this.devicePixelRatio,
          this.imgHeight * this.devicePixelRatio
        );
      this.$hideLoading() 
      };
    },
    clsInterval() {
      clearInterval(this.interval);
      this.interval = null;
    },

    readyMove(ev) {
      let startX;
      if (ev.screenX) {
        startX = ev.screenX;
      } else {
        startX = ev.touches[0].clientX;
      }

      // let x = ''
      // let y = ''

      let moveHandle = ev => {
        let moveX;
        if (ev.screenX) {
          moveX = ev.screenX;
        } else {
          moveX = ev.touches[0].clientX;
        }

        this.direction =
          moveX - startX >= 0 ? (moveX - startX > 0 ? "right" : "") : "left";

        ev.preventDefault();
        ev.stopPropagation();
      };

      let upHandle = () => {
        document.removeEventListener("touchmove", moveHandle, {
          passive: false
        });
        document.removeEventListener("touchend", upHandle);
        document.removeEventListener("mousemove", moveHandle, {
          passive: false
        });
        document.removeEventListener("mouseup", upHandle);
      };

      document.addEventListener("touchmove", moveHandle, { passive: false });
      document.addEventListener("touchend", upHandle);
      document.addEventListener("mousemove", moveHandle, { passive: false });
      document.addEventListener("mouseup", upHandle);
    }
  },
  mounted() {
    this.readyMove = this.readyMove.bind(this);
    this.$refs.layout.addEventListener("mousedown", this.readyMove);
    this.$refs.layout.addEventListener("touchstart", this.readyMove);
    this.init();
  },
  beforeDestroy() {
    this.$refs.layout.removeEventListener("mousedown", this.readyMove);
    this.$refs.layout.removeEventListener("touchstart", this.readyMove);
  }
};
</script>

<style lang="less" scoped>
.l_bg{
  #canvas {
    overflow: hidden;
  }
}

</style>